<template v-if="products">
	<div class="product-carousel-wrap">
		<div class="container">
			<h3 class="title center">
				<span v-html="title"></span>
			</h3>
			<Slick ref="slick" :options="slickOptions">
				<div class="products-carousel-item" v-for="(product, index) in products" v-bind:key="index">
					<div>
						<Product
							ref="productComponent"
							:product="product"
							:index="index"
							:key="product.id"
							:lazy_image="false"
						></Product>
					</div>
				</div>
			</Slick>
		</div>
	</div>
</template>

<script>
	import Product from "@/components/Product/Product.vue";
	import Slick from "vue-slick";
	import { mapState } from "vuex";

	export default {
		name: "productsCarousel",
		props: ["title", "products"],
		data() {
			return {
				slickOptions: {
					slidesToShow: 6,
					slidesToScroll: 1,
					rtl: true,
					dots: true,
					arrows: false,
					infinite: true,
					autoplay: true,
					autoplaySpeed: 5000,
					pauseOnFocus: true,
					lazyLoad: false,
					touchThreshold: 10,
					responsive: [
						{
							breakpoint: 1700,
							settings: {
								slidesToShow: 6,
								slidesToScroll: 1,
								dots: true,
								arrows: false,
							},
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								centerMode: false,
								variableWidth: true,
								dots: true,
								arrows: false,
							},
						},
					],
				},
			};
		},
		mounted() {
			setTimeout(() => {
				let width = $("section.hp_products .product_wrap:first-child .product").width();
				console.log("width", width);
				$("section.product-carousel-section .product_wrap").css("width", width + "px");
			}, 100);
		},
		methods: {},
		computed: {
			page: function () {
				if (typeof wpData.pageData != "object") {
					return JSON.parse(wpData.pageData);
				}
				return wpData.pageData;
			},
		},
		components: {
			Slick,
			Product,
		},
	};
</script>

<style lang="scss" scoped>
	//::v-deep .slick-track {
	//  display: flex !important;
	//  transform: none !important;
	//  transition: none !important;
	//  will-change: auto;
	//}
	.product-carousel-wrap {
		overflow: hidden;

		@media (max-width: 480px) {
			.container {
				padding: 0;
				margin-bottom: 3em;
			}
		}

		.title {
			color: #355731;
		}

		.products-carousel-item {
			//@media (max-width: 480px) {
			//  width: 174px !important;
			//}

			.product_wrap {
				@media (min-width: 1024px) {
					padding: 0 15px;
					width: 100% !important;
				}
			}
		}

		::v-deep a.slick-arrow {
			position: absolute;
			top: 50%;
			margin: -2em -4em 0;
			background: #1e824c;
			border-radius: 100%;
			height: 50px;
			width: 50px;
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 1;

			@media (min-width: 1024px) {
				&.arrow-left {
					left: 0;
				}

				&.arrow-right {
					right: 0;
				}
			}

			@media (max-width: 1024px) {
				top: auto;
				bottom: 0;
				margin: 0 7px;
				height: 36px;
				width: 36px;

				&.arrow-left {
					right: 50%;
				}

				&.arrow-right {
					left: 50%;
				}

				svg {
					width: 20px;
				}
			}
		}
	}

	::v-deep .slick-slider {
		padding-bottom: 3em;

		@media (max-width: 480px) {
			padding-bottom: 2em;
		}
	}
</style>
